import { render, staticRenderFns } from "./dialogStart.vue?vue&type=template&id=b81682a6&scoped=true"
import script from "./dialogStart.vue?vue&type=script&lang=js"
export * from "./dialogStart.vue?vue&type=script&lang=js"
import style0 from "./dialogStart.vue?vue&type=style&index=0&id=b81682a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81682a6",
  null
  
)

export default component.exports